<!-- Address fields from dynamic form -->
<ng-container *ngFor="let section of schema; let i = index;">
  <div class="section"
    *ngIf="visibility[i]?.visible"
    [class]="section.size || ''"
    [ngClass]="section.customClass"
    [ngStyle]="section.customStyle">
    <!-- Title -->
    <div class="title">{{section.label}}</div>

    <!-- Content -->
    <div class="content">
      <ng-container *ngFor="let child of section.childs">
        <ng-container *ngIf="child.visible !== false">
          <app-form-field
            class="field"
            [class]="child.size || ''"
            [ngClass]="child.customClass"
            [ngStyle]="child.customStyle"
            [type]="child.type"
            [label]="child.label"
            [hideLabel]="child.hideLabel"
            [hintMsg]="child.hintMsg"
            [placeholder]="child.placeholder"
            [fieldControl]="child.fieldControl | asFormControl"
            [customFieldData]="child.customFieldData"
            [options]="child.options"
            [readOnly]="child.readOnly"
            [inputPattern]="child.inputPattern"
            [capitalize]="child.capitalize"
            [uppercase]="child.uppercase"
            [errorMsg]="child.errorMsg ?? ''"
            [customStyle]="child.customStyle">
          </app-form-field>
        </ng-container>
      </ng-container>

      <!-- Cascading INE dropdowns -->
      <app-form-field
        class="field col-4"
        type="select"
        label="Comunidad"
        placeholder="Comunidad autónoma"
        [fieldControl]="$any(communityControl)"
        [options]="communityOptions"
        [filterSelect]="true">
      </app-form-field>
      <app-form-field
        class="field col-4"
        type="select"
        label="Provincia"
        placeholder="Provincia de CCAA"
        [fieldControl]="$any(provinceControl)"
        [options]="provinceOptions"
        [filterSelect]="true">
      </app-form-field>
      <app-form-field
        class="field col-4"
        type="select"
        label="Municipio"
        placeholder="Municipio provincial"
        [fieldControl]="$any(municipalityControl)"
        [options]="municipalityOptions"
        [filterSelect]="true">
      </app-form-field>
    </div>
  </div>
</ng-container>

<!-- Tutors section -->
<div class="section col-12">
  <div class="title">Tutores</div>

  <div class="add-tutor" (click)="addTutor()">
    <button mat-icon-button matTooltip="Añadir tutor" class="add-tutor-button">
      <mat-icon>add</mat-icon>
    </button>
    <span>Añadir tutor</span>
  </div>

  <div class="tutor-row" *ngFor="let tutor of tutorsFormArray.controls; let idx = index">
    <app-form-field
      class="tutor-field"
      type="text"
      label="Nombre"
      [fieldControl]="$any(tutor.get('name'))">
    </app-form-field>
    <app-form-field
      class="tutor-field"
      type="text"
      label="Apellidos"
      [fieldControl]="$any(tutor.get('surnames'))">
    </app-form-field>
    <app-form-field
      class="tutor-field"
      type="select"
      label="Parentesco"
      [fieldControl]="$any(tutor.get('relationship'))"
      [options]="relationshipOptions">
    </app-form-field>
    <app-form-field
      class="tutor-field"
      type="text"
      label="Teléfono"
      [fieldControl]="$any(tutor.get('phone'))">
    </app-form-field>
    <button mat-icon-button color="warn" class="delete-button" (click)="removeTutor(idx)" matTooltip="Eliminar tutor">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="no-tutors" *ngIf="tutorsFormArray.length === 0">
    No hay tutores registrados
  </div>
</div>
